import React, { Component } from 'react';
import {setAndGetAttributes} from './FormInputFunctions';
import Wrp from "../../hoc/Wrp/Wrp";

class Email extends Component {

  fieldOnChangeHandler(e){
    const {changeHandler,isEvent} = this.props;
    if(isEvent===true){
      changeHandler(e.target.value,e);
    }else{
      changeHandler(e.target.value);
    }
  } 

  render() {
    const {value} = this.props;
    let attr = setAndGetAttributes(this.props);
    
    return (
      <Wrp>
        <input 
          type="text"
          {...attr}
          onChange={e=>this.fieldOnChangeHandler(e)}
          value={value}
        />
      </Wrp>        
    );
  }
}

Email.defaultProps = {
  isMandatory:false,
  className: 'form-control',
  isEvent:false
}

export default Email;